import { useLayoutEffect } from 'react';

/**
 * Hook that measures an element's height and sets it as a CSS variable
 * @param {React.RefObject} ref - Reference to the element to measure
 * @param {string} varName - CSS variable name (e.g., '--bottom-nav-height')
 */
export function useMeasureToCssVar(ref, varName) {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const root = document.documentElement;
    
    const setVar = () => {
      const height = Math.round(el.offsetHeight);
      root.style.setProperty(varName, `${height}px`);
    };

    // Initial measurement
    setVar();

    // Watch for size changes
    const resizeObserver = new ResizeObserver(setVar);
    resizeObserver.observe(el);

    // Also listen to window resize events
    window.addEventListener('resize', setVar);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', setVar);
    };
  }, [ref, varName]);
}

export default useMeasureToCssVar;
